import { render, staticRenderFns } from "./ComplianceReport.vue?vue&type=template&id=28c0485e&scoped=true"
import script from "./ComplianceReport.vue?vue&type=script&lang=js"
export * from "./ComplianceReport.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReport.vue?vue&type=style&index=0&id=28c0485e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0485e",
  null
  
)

export default component.exports